import MenuService from "../../core/components/menu/MenuService";
import MenuItem from "../../core/components/menu/MenuItem";
import i18n from '../../shared/i18n'
import Invoices from './invoices/Invoices.module';
import InvoicePayments from './invoice-payments/InvoicePayments.module';
import SettlementPayments from './settlement-payments/SettlementPayments.module';
import Shipping from './shipping/Shipping.module';
import Settlements from './settlements/Settlements.module';
// import Checks from "@/modules/checks/checks.module.js";
// import Bacs from "@/modules/bacs-payments/bacs.module.js";

MenuService.addMenuItem(new MenuItem('/finance', i18n.t('Finance'), 6, 'wallet', [
  Invoices.menuItem,
  Settlements.menuItem,
  Shipping.menuItem,
  // Checks.menuItem,
  // Bacs.menuItem,
  InvoicePayments.menuItem,
  SettlementPayments.menuItem
], ['OR', 'view_invoice', 'view_settlement', 'checks_view']));

const routes = [
  ...Invoices.routes,
  ...Settlements.routes,
  ...Shipping.routes,
  // ...Checks.routes,
  // ...Bacs.routes,
  ...InvoicePayments.routes,
  ...SettlementPayments.routes,
]

export {routes}
